export const printTemplate = /\$([\w.]+)/g
